import { FC } from "react";
import { Modal, Button, Text } from "@mantine/core";
import { useStyle } from "./RegtankOnboardingModalCss.styles";

interface RegtankOnboardingProps {
  opened: boolean;
  onClose: () => void;
  title: string;
  firstLine: string;
  secondLine: string;
  onButtonClick: () => void;
  isLoadingOnboarding: boolean;
}

export const RegtankOnboardingModal: FC<RegtankOnboardingProps> = ({
  opened,
  onClose,
  title,
  firstLine,
  secondLine,
  onButtonClick,
  isLoadingOnboarding,
}) => {
  const { classes } = useStyle();
  return (
    <Modal
      classNames={{
        header: classes.modalHeader,
        title: classes.modalTitle,
      }}
      title={title}
      centered
      size="30%"
      overlayProps={{
        blur: 3,
        opacity: 0.1,
      }}
      opened={opened}
      onClose={onClose}
      closeOnEscape={false}
      closeOnClickOutside={false}
      withCloseButton={false}
    >
      <div className={classes.firstLineDiv}>
        <Text>{firstLine}</Text>
      </div>
      <div className={classes.secLineDiv}>
        <Text>{secondLine}</Text>
      </div>
      <div className={classes.buttonDiv}>
        <Button
          onClick={onButtonClick}
          className={classes.button}
          loading={isLoadingOnboarding}
        >
          Start Verification
        </Button>
      </div>
    </Modal>
  );
};
